import { motion } from 'framer-motion';
import { tProfilingState } from '../../providers/ProfilingProgressProvider/ProfilingProgress.types';

export type tNavbarProfilingIndicatorProps = {
  state: tProfilingState;
};

type tPhaseLabel = {
  name: string;
  percent: number;
};

const SCENE_LABELS: Record<string, string> = {
  contacts: 'Sincronizando contactos',
  history: 'Descargando historial',
  profiling: 'Organizando conversaciones',
};

const getPhaseInfo = (state: tProfilingState): tPhaseLabel => {
  if (!state.active && state.profiled >= state.total && state.total > 0) {
    return { name: 'Listo', percent: 100 };
  }

  const name = SCENE_LABELS[state.scene] ?? 'Procesando';

  return { name, percent: state.globalProgress };
};

export default function NavbarProfilingIndicator(props: tNavbarProfilingIndicatorProps) {
  const { state } = props;
  const phase = getPhaseInfo(state);

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.9 }}
      transition={{ duration: 0.3 }}
      className="hidden items-center gap-3 rounded-full border border-primary/20 bg-primary/5 px-4 py-2 sm:flex"
    >
      <span className="loading loading-spinner loading-xs text-primary" />
      <div className="flex items-center gap-2">
        <span className="text-xs font-medium text-base-content">
          {phase.name}
        </span>
        <span className="text-xs font-bold text-primary">
          {phase.percent}%
        </span>
      </div>
      <div className="h-1.5 w-20 overflow-hidden rounded-full bg-base-200">
        <motion.div
          className="h-full rounded-full bg-primary"
          animate={{ width: `${phase.percent}%` }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
        />
      </div>
    </motion.div>
  );
}
